module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pkweBm/CoverDesign.jpg?1684514925455",
      "alt": "This image is the cover for the book Ses deux papas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ses deux papas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Srikkanth Bhattacharya est le célibataire gay par excellence et parfaitement heureux de l’être, jusqu’à ce qu’il reçoive un appel de l’hôpital local lui annonçant que sa meilleure amie est morte en couches. Sri avait accepté de donner son sperme afin que le rêve de maternité de Jill se réalise, mais il ne s’était pas attendu à être responsable d’une petite fille. Il décide de la placer dans une famille adoptive, mais une fois qu’il la voit, Sri ne peut se résoudre à le faire, et se débat maintenant pour apprendre à s’occuper d’un nouveau-né.")]), _vm._v(" "), _c('p', [_vm._v("Son colocataire et ami, Jaime Frias, propose de l’aider, ne se doutant pas qu’il allait tomber amoureux du bébé et de Sri. Tout semble parfait jusqu’à ce qu’une visite des Services Sociaux plonge Sri dans le désarroi, lui donnant l’impression qu’il doit choisir entre sa fille et une relation avec l’homme qu’il était venu à aimer.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ariel Tachna, Jade Baiser\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0